import {Component, OnInit, ViewEncapsulation, CUSTOM_ELEMENTS_SCHEMA, Input, ChangeDetectorRef, ViewChild, OnChanges, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule, AbstractControl, ValidatorFn } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatSnackBarModule, MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PromptsDTO } from '../../models/promts.dto';
import {OrganisationDTO} from "../../../../../DTO/Organisation/OrganisationDTO";
import {PromtsManagemetServices} from "../../services/promts-managemet.services";
import { LocalizationPipe } from '../../../../../pipe/localization-pipe';
import { LocalizationService } from '../../../../../services/localizationService';
import {PermissionService} from "../../../../../../core/authorization/permission.service";
import { PromptCreateComponent, PromptFormMode } from '../prompt-create/prompt-create.component';
import { Router } from '@angular/router';
import { DeleteConfirmationDialogComponent, DeleteConfirmationData } from '../../../file/resource-management/delete-confirmation-dialog.component';

@Component({
  selector: 'app-prompt-management',
  templateUrl: './prompt-management.component.html',
  styleUrls: ['./prompt-management.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDialogModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatMenuModule,
    RouterModule,
    LocalizationPipe
  ]
})
export class PromptManagementComponent implements OnInit, OnChanges {
  @ViewChild(PromptCreateComponent) promptCreateComponent: PromptCreateComponent;
  @Input() selectedOrganisationId?: number;
  @Input() loadOnInit: boolean = true;
  @Input() organisationComponent: boolean;

  prompts: PromptsDTO[] = [];
  loading = false;
  selectedOrganization = new OrganisationDTO();

  // Tablo sütun tanımları
  displayedColumns: string[] = ['id', 'promptName', 'type', 'actions'];

  // Tablo başlıkları için eşleme
  columnHeaderMap = {
    'id': 'Prompts.TableHeaders.Id',
    'promptName': 'Prompts.TableHeaders.PromptName',
    'promptText': 'Prompts.TableHeaders.PromptText',
    'type': 'Prompts.TableHeaders.Type',
    'actions': 'Prompts.TableHeaders.Actions'
  };

  // Type görünüm eşleştirmeleri
  typeDisplayMap = {
    'DOCUMENT_PARSER': 'Prompts.PromptTypes.DocumentParser',
    'MULTIMEDIA_ANALYZER': 'Prompts.PromptTypes.MultimediaAnalyzer',
    'ORGANIZATION': 'Prompts.PromptTypes.Organization',
    'WEB_PAGE': 'Prompts.PromptTypes.WebPage',
    'WEB_SERVICES': 'Prompts.PromptTypes.WebServices',
    'INTEGRATION': 'Prompts.PromptTypes.Integration',
    'TEXT': 'Prompts.PromptTypes.Text',
  };

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private toastr: ToastrService,
    private promtService: PromtsManagemetServices,
    public permissionService:PermissionService,
    public localizationService: LocalizationService,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    if (this.loadOnInit || this.loadOnInit==undefined) {
      this.loadPrompts();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedOrganisationId'] || changes['organisationComponent']) {
      if (this.selectedOrganisationId && (this.loadOnInit || this.loadOnInit==undefined)) {
        this.selectedOrganization = new OrganisationDTO();
        this.selectedOrganization.id = this.selectedOrganisationId;
        this.loadPrompts();
      }
    }
  }

  public loadPrompts(): void {
    this.loading = true;
    if (this.selectedOrganisationId) {
      this.selectedOrganization = new OrganisationDTO();
      this.selectedOrganization.id = this.selectedOrganisationId;
    } else if (window.globalActiveUser && window.globalActiveUser.organisationAccount && window.globalActiveUser.organisationAccount.id) {
      this.selectedOrganization = new OrganisationDTO();
      this.selectedOrganization.id = window.globalActiveUser.organisationAccount.id;
    }
    this.promtService.getOrganizationPromts(this.selectedOrganization).subscribe(
      (res) => {
        if(res && res["data"]){
          this.prompts=[];
          for(let i=0;i<res["data"].length;i++){
            let _promt=new PromptsDTO();
            _promt.bindData(res["data"][i]);
            this.prompts.push(_promt);
          }
        }
        this.loading = false;
        this.cdr.detectChanges();
      },
      (error) => {
        this.snackBar.open(
          this.localizationService.getLocalizationValue('Prompts.LoadingError'),
          this.localizationService.getLocalizationValue('Common.Ok'),
          { duration: 3000 }
        );
        this.loading = false;
        this.cdr.detectChanges();
      }
    );
  }

  getColumnHeader(column: string): string {
    return this.columnHeaderMap[column] || column;
  }

  getTypeDisplay(type: string): string {
    return this.typeDisplayMap[type] || type;
  }

  deletePrompt(prompt: PromptsDTO): void {
    const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, {
      width: '400px',
      data: {
        fileName: prompt.promptName || 'İsimsiz Prompt',
        modalTitle: this.localizationService.getLocalizationValue('Prompts.DeleteConfirmation.Title'),
        modalQuestion: this.localizationService.getLocalizationValue('Prompts.DeleteConfirmation.Message')
      } as DeleteConfirmationData,
      disableClose: true
    });

    const dialogComponent = dialogRef.componentInstance;

    dialogComponent.deleteConfirmed.subscribe(() => {
      this.toastr.info(
        this.localizationService.getLocalizationValue('Prompts.DeleteProcess'),
        this.localizationService.getLocalizationValue('Common.Info')
      );

      this.promtService.deletePrompt(prompt.id).subscribe(
        (response) => {
          this.toastr.success(
            this.localizationService.getLocalizationValue('Prompts.DeleteSuccess'),
            this.localizationService.getLocalizationValue('Common.Success')
          );
          this.loadPrompts();
          dialogRef.close();
        },
        (error) => {
          this.toastr.error(
            this.localizationService.getLocalizationValue('Prompts.DeleteError'),
            this.localizationService.getLocalizationValue('Common.Error')
          );
          dialogRef.close();
        }
      );
    });
  }

  protected readonly window = window;
}
